var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"dense":"","outlined":"","item-text":"nome","return-object":"","placeholder":_vm.placeholder,"label":_vm.label,"rules":[_vm.rules.required],"items":_vm.items},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})
}
var staticRenderFns = []

export { render, staticRenderFns }